import { BaseObject } from 'src/app/models/base-object.model';
import { HateoasResource } from '@lagoshny/ngx-hateoas-client';

@HateoasResource('wiki')
export class Wiki extends BaseObject {
  public component!: string;
  public pageId!: number;
  public url!: string;
  public active!: boolean;
}
